import { Directive } from '@angular/core';

@Directive({
  selector: '[contentBodyBasicAccordion]',
})
export class ContentBodyBasicAccordionDirective {
  constructor() {}
}
